module.exports = __webpack_public_path__ + "img/logo_omni.fb43832f.png";